var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFootermail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28949 4.90755C10.4241 4.63506 13.5765 4.63506 16.7111 4.90755L18.2214 5.03883C19.2267 5.12623 20.0878 5.7259 20.534 6.58368C20.591 6.69341 20.5483 6.82627 20.4431 6.89138L14.1771 10.7703C12.8333 11.6022 11.1387 11.6197 9.77802 10.8156L3.4702 7.08827C3.36829 7.02805 3.32151 6.90408 3.36744 6.79498C3.77559 5.82542 4.69322 5.13324 5.77925 5.03883L7.28949 4.90755Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3623 8.76682C3.20634 8.67466 3.00734 8.77383 2.98916 8.95408C2.73542 11.4697 2.79683 14.0092 3.17339 16.5133C3.3719 17.8334 4.44931 18.8454 5.77926 18.961L7.28949 19.0923C10.4241 19.3648 13.5765 19.3648 16.7111 19.0923L18.2214 18.961C19.5513 18.8454 20.6287 17.8334 20.8272 16.5133C21.2148 13.9362 21.2685 11.3217 20.9885 8.73422C20.9688 8.5527 20.7665 8.45535 20.6112 8.55145L14.9667 12.0457C13.1485 13.1712 10.8559 13.1949 9.01493 12.107L3.3623 8.76682Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootermail);
export default __webpack_public_path__ + "static/media/footermail.7c5a0d578f4c053783439229a65811ad.svg";
export { ForwardRef as ReactComponent };